/**
 * A module containing utilities for interacting with page data.
 * @module abt-utils/page-data
 */

import _ from 'lodash'
import siteConfig from '../abt-core/site-config.json'

/**
 * Checks if a page data property is in a collection.
 * @param {string} path - The path of the page data property to evaluate.
 * @param {array} collection - The collection to search.
 * @returns {boolean} Returns TRUE if property exists and is in the collection, otherwise FALSE.
 */
export function contains (path, collection) {
  return _.includes(collection, get(path))
}

/**
 * Gets the page data object or an individual property.
 * @param {string} path - The path of the page data property to get.
 * @returns {*} Returns the page data object or individual property value.
 */
export function get (path) {
  var pageData = window[siteConfig.analyticsData] || {}

  // TODO: replace pageData[path] -> _.get(pageData, path) when lodash 3.10.1 is available.
  // TODO: add unit test to check _.get dot syntax works correctly.
  return path ? pageData[path] : pageData
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-utils/page-data.js
 ** module id = 9
 ** module chunks = 2 3
 **/